import React, { useState } from 'react';
import '../../css/sliderMB.css';
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";
import { useUltraMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const SliderSettings = (props) => {

    const {
        listRespData,
    } = props;

    const isMobile = useUltraMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const [swiperIndexFirst, setSwiperIndexFirst] = useState(0);
    const [swiperInstanceFirst, setSwiperInstanceFirst] = useState(null);

    const handleSwiperSlideChangeFirst = (swiperFirst) => {
        setSwiperIndexFirst(swiperFirst.activeIndex);
    };

    const nextImageFirst = () => {
        if (swiperInstanceFirst !== null) {
            swiperInstanceFirst.slideNext();
        }
    };

    const prevImageFirst = () => {
        if (swiperInstanceFirst !== null) {
            swiperInstanceFirst.slidePrev();
        }
    };

  return (
    <div className={isTablet ? 'mainSecondViewContainerSliderMB' : 'mainSecondViewContainerSliderMBMobile'}>

        <Swiper
            onSlideChange={(swiperFirst) => handleSwiperSlideChangeFirst(swiperFirst)}
            onSwiper={(swiperFirst) => setSwiperInstanceFirst(swiperFirst)}
            slidesPerView={1}
            centeredSlides={true}
            autoplay={{
                delay: 6000,
                disableOnInteraction: false,
            }}
            // pagination={{
            // clickable: true,
            // }}
            navigation={false}
            modules={[Autoplay, Pagination, Navigation]}
            className={isTablet ? "mySwiperSliderMB" : "mySwiperSliderMBMobile"}
        >
            {listRespData.map((item, index) => (
                <SwiperSlide key={index}>
                    <div className={ isTablet ? 'secondSubMainContainerSliderMB' : 'secondSubMainContainerSliderMBMobile' }>
                        { isTablet ? (
                            <>
                            <div className='imgAddCardMainViewSliderMB' style={{ backgroundImage: `url(${item.imgUnlinkCard.desktop})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                                {/* <img src={item.imgUnlinkCard} alt="imagem"  className={ isTablet ? 'imgAddCardSliderMB' : 'imgAddCardSliderMBMobile' } /> */}
                            </div>
                            <div className='txtAddCardMainViewSliderMB'>
                                <div className='txtAddCardMainTwoViewSliderMB'>
                                    <div className='txtAddCardMainTitleViewSliderMB'>
                                        <div className='txtAddCardBoldSliderMBUnlink'>{item.titleUnlinkCard}</div>
                                    </div>
                                    <div className='txtAddCardMainSubTitleViewSliderMBUnlink'>
                                        <div className='txtAddCardRegularSliderMBUnlink' style={{ marginBottom: '16px' }}>{item.txtUnlinkCard}</div>
                                        <div className='txtAddCardRegularSliderMBUnlink'>{item.descUnlinkCard}</div>
                                    </div>
                                </div>
                            </div>
                            </>
                        ) : ( isMobile ? (
                            <>
                            <div className='imgAddCardMainViewSliderMBMobile'>
                                <img src={item.imgUnlinkCard.tablet} alt="imagem"  className='imgAddCardSliderMBMobile'/>
                            </div>
                            <div className='txtAddCardMainViewSliderMBMobile'>
                                <div className='txtAddCardMainTitleViewSliderMB'>
                                    <div className='txtAddCardBoldSliderMBUnlink'>{item.titleUnlinkCard}</div>
                                </div>
                                <div className='txtAddCardMainSubTitleViewSliderMB'>
                                    <span className='txtAddCardRegularSliderMBUnlink'> {item.txtUnlinkCard}</span>
                                    <span className='txtAddCardRegularSliderMBUnlink'> {item.descUnlinkCard}</span>
                                </div>
                            </div>
                            </>
                            ) : ( 
                            <>
                            <div className='imgAddCardMainViewSliderMBMobile'>
                                <img src={item.imgUnlinkCard.mobile} alt="imagem"  className='imgAddCardSliderMBMobile'/>
                            </div>
                            <div className='txtAddCardMainViewSliderMBMobile'>
                                <div className='txtAddCardMainTitleViewSliderMB'>
                                    <div className='txtAddCardBoldSliderMBUnlink'>{item.titleUnlinkCard}</div>
                                </div>
                                <div className='txtAddCardMainSubTitleViewSliderMB'>
                                    <span className='txtAddCardRegularSliderMBUnlink'> {item.txtUnlinkCard}</span>
                                    <span className='txtAddCardRegularSliderMBUnlink'> {item.descUnlinkCard}</span>
                                </div>
                            </div>
                            </>
                        ))}
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>

        <div className={isTablet ? 'thirdSubMainContainerCircleNavSliderMB' : 'thirdSubMainContainerSliderMBMobile'}>
            <button className='iconArrowLeftViewContainerSliderMB' onClick={prevImageFirst} disabled={swiperIndexFirst == 0}>
                <FaArrowLeftLong className='iconArrowSliderMB' />
            </button>

            <div className='cirlceSelectedSliderMB'>
                <div className='circleMainvViewSliderMB'>
                    <div className='circleContainerSliderMB'>
                        <div className={swiperIndexFirst == 0 ? 'circleSelectedViewSliderMB' : 'circleViewSliderMB'} />
                    </div>
                    <div className='circleContainerSliderMB'>
                        <div className={swiperIndexFirst == 1 ? 'circleSelectedViewSliderMB' : 'circleViewSliderMB'} />
                    </div>
                    <div className='circleContainerSliderMB'>
                        <div className={swiperIndexFirst >= 2 ? 'circleSelectedViewSliderMB' : 'circleViewSliderMB'} />
                    </div>
                </div>
            </div>

            <button className='iconArrowRightViewContainerSliderMB' onClick={nextImageFirst} disabled={swiperIndexFirst >= listRespData.length - 1}>
                <FaArrowRightLong className='iconArrowSliderMB' />
            </button>
        </div>

    </div>
  )
}

export default SliderSettings;